<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "./utils/basics.less";
import "./utils/app.css";
import autofit from "autofit.js";

export default {
  name: "app",
  components: {
  },
  computed: {
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {
    autofit.init({
      dh: 1080,
      dw: 1920,
      el: "#app",
      resize: true,
    }, false);
  },
  methods: {

  },
};
</script>

<style lang='less'>
body {
  padding-right: 0 !important;
}

.el-dialog {
  border-radius: 12px;
}

.v-modal {
  z-index: 999 !important;
}

.el-dialog__wrapper {
  z-index: 1000 !important;
}

.el-message {
  z-index: 9999 !important;
  position: fixed !important;
  right: 20px !important;
  bottom: 20px !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  min-width: 300px;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.el-message--warning{
  display: none !important;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield !important;
}

input[aria-hidden=true] {
  display: none !important;
}
</style>
